@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.danko.roblox_craft_ai.components.layouts.LegalLayout as _dev_danko_roblox_craft_ai_components_layouts_LegalLayout
import dev.danko.roblox_craft_ai.components.layouts.MarkdownLayout as _dev_danko_roblox_craft_ai_components_layouts_MarkdownLayout
import dev.danko.roblox_craft_ai.components.layouts.PageLayout as _dev_danko_roblox_craft_ai_components_layouts_PageLayout
import dev.danko.roblox_craft_ai.pages.AboutPage as _dev_danko_roblox_craft_ai_pages_AboutPage
import dev.danko.roblox_craft_ai.pages.AdminPage as _dev_danko_roblox_craft_ai_pages_AdminPage
import dev.danko.roblox_craft_ai.pages.DocsPage as _dev_danko_roblox_craft_ai_pages_DocsPage
import dev.danko.roblox_craft_ai.pages.HomePage as _dev_danko_roblox_craft_ai_pages_HomePage
import dev.danko.roblox_craft_ai.pages.PricingPage as _dev_danko_roblox_craft_ai_pages_PricingPage
import dev.danko.roblox_craft_ai.pages.PromptsPage as _dev_danko_roblox_craft_ai_pages_PromptsPage
import dev.danko.roblox_craft_ai.pages.SettingsPage as _dev_danko_roblox_craft_ai_pages_SettingsPage
import dev.danko.roblox_craft_ai.pages.WelcomePage as _dev_danko_roblox_craft_ai_pages_WelcomePage
import dev.danko.roblox_craft_ai.pages.auth.VerifyPage as _dev_danko_roblox_craft_ai_pages_auth_VerifyPage
import dev.danko.roblox_craft_ai.pages.legal.en.PrivacyPage as _dev_danko_roblox_craft_ai_pages_legal_en_PrivacyPage
import dev.danko.roblox_craft_ai.pages.legal.en.RefundsPage as _dev_danko_roblox_craft_ai_pages_legal_en_RefundsPage
import dev.danko.roblox_craft_ai.pages.legal.en.TermsPage as _dev_danko_roblox_craft_ai_pages_legal_en_TermsPage
import dev.danko.roblox_craft_ai.pages.legal.ru.PrivacyPage as _dev_danko_roblox_craft_ai_pages_legal_ru_PrivacyPage
import dev.danko.roblox_craft_ai.pages.legal.ru.RefundsPage as _dev_danko_roblox_craft_ai_pages_legal_ru_RefundsPage
import dev.danko.roblox_craft_ai.pages.legal.ru.TermsPage as _dev_danko_roblox_craft_ai_pages_legal_ru_TermsPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Craftiva AI"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
        ) { pageCtx, pageMethod -> 
            _dev_danko_roblox_craft_ai_components_layouts_LegalLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.danko.roblox_craft_ai.components.layouts.MarkdownLayout",
            parentLayoutId = "dev.danko.roblox_craft_ai.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_danko_roblox_craft_ai_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.danko.roblox_craft_ai.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _dev_danko_roblox_craft_ai_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_AboutPage()
        }
        ctx.router.register(
            "/admin",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initAdminPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_AdminPage()
        }
        ctx.router.register(
            "/auth/verify",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.auth.initVerifyPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_auth_VerifyPage()
        }
        ctx.router.register(
            "/docs",
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_DocsPage()
        }
        ctx.router.register(
            "/legal/en/privacy",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.en.initPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_en_PrivacyPage()
        }
        ctx.router.register(
            "/legal/en/refunds",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.en.initRefundsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_en_RefundsPage()
        }
        ctx.router.register(
            "/legal/en/terms",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.en.initTermsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_en_TermsPage()
        }
        ctx.router.register(
            "/legal/ru/privacy",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.ru.initPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_ru_PrivacyPage()
        }
        ctx.router.register(
            "/legal/ru/refunds",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.ru.initRefundsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_ru_RefundsPage()
        }
        ctx.router.register(
            "/legal/ru/terms",
            layoutId = "dev.danko.roblox_craft_ai.components.layouts.LegalLayout",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.legal.ru.initTermsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_legal_ru_TermsPage()
        }
        ctx.router.register(
            "/pricing",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initPricingPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_PricingPage()
        }
        ctx.router.register(
            "/prompts",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initPromptsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_PromptsPage()
        }
        ctx.router.register(
            "/settings",
            initRouteMethod = { ctx ->
                dev.danko.roblox_craft_ai.pages.initSettingsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_SettingsPage()
        }
        ctx.router.register(
            "/welcome",
        ) { pageCtx -> 
            _dev_danko_roblox_craft_ai_pages_WelcomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", dev.danko.roblox_craft_ai.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", dev.danko.roblox_craft_ai.SubheadlineTextStyle)
        ctx.theme.registerStyle("footer", dev.danko.roblox_craft_ai.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", dev.danko.roblox_craft_ai.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("settings-tab", dev.danko.roblox_craft_ai.components.SettingsTabStyle)
        ctx.theme.registerStyle("settings-tab-active", dev.danko.roblox_craft_ai.components.SettingsTabActiveStyle)
        ctx.theme.registerStyle("settings-card", dev.danko.roblox_craft_ai.components.SettingsCardStyle)
        ctx.theme.registerStyle("settings-input", dev.danko.roblox_craft_ai.components.SettingsInputStyle)
        ctx.theme.registerStyle("sync-modal-type-chip", dev.danko.roblox_craft_ai.components.SyncModalTypeChipStyle)
        ctx.theme.registerStyle("legal-prose", dev.danko.roblox_craft_ai.components.layouts.LegalProseStyle)
        ctx.theme.registerStyle("markdown", dev.danko.roblox_craft_ai.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", dev.danko.roblox_craft_ai.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("queue-panel-sheet", dev.danko.roblox_craft_ai.components.QueuePanelSheetStyle)
        ctx.theme.registerStyle("queue-header", dev.danko.roblox_craft_ai.components.QueueHeaderStyle)
        ctx.theme.registerStyle("site-header", dev.danko.roblox_craft_ai.components.SiteHeaderStyle)
        ctx.theme.registerStyle("nav-link", dev.danko.roblox_craft_ai.components.NavLinkStyle)
        ctx.theme.registerStyle("pill", dev.danko.roblox_craft_ai.components.PillStyle)
        ctx.theme.registerStyle("menu-item", dev.danko.roblox_craft_ai.components.MenuItemStyle)
        ctx.theme.registerStyle("session-token-input", dev.danko.roblox_craft_ai.components.SessionTokenInputStyle)
        ctx.theme.registerStyle("concept-preview-box", dev.danko.roblox_craft_ai.components.ConceptPreviewBoxStyle)
        ctx.theme.registerStyle("token-saving-badge", dev.danko.roblox_craft_ai.components.TokenSavingBadgeStyle)
        ctx.theme.registerStyle("session-token-badge", dev.danko.roblox_craft_ai.pages.SessionTokenBadgeStyle)
        ctx.theme.registerStyle("main-container", dev.danko.roblox_craft_ai.pages.MainContainerStyle)
        ctx.theme.registerStyle("connection-dot", dev.danko.roblox_craft_ai.pages.ConnectionDotStyle)
        ctx.theme.registerStyle("works-grid", dev.danko.roblox_craft_ai.pages.WorksGridStyle)
        ctx.theme.registerStyle("settings-container", dev.danko.roblox_craft_ai.pages.SettingsContainerStyle)
        ctx.theme.registerStyle("prompts-grid", dev.danko.roblox_craft_ai.pages.PromptsGridStyle)
        ctx.theme.registerStyle("pipeline-running-pulse", dev.danko.roblox_craft_ai.uikit.components.PipelineRunningPulseStyle)
        ctx.theme.registerStyle("pipeline-container", dev.danko.roblox_craft_ai.uikit.components.PipelineContainerStyle)
        ctx.theme.registerStyle("step-node", dev.danko.roblox_craft_ai.uikit.components.StepNodeStyle)
        ctx.theme.registerStyle("chat-drawer-overlay", dev.danko.roblox_craft_ai.uikit.components.ChatDrawerOverlayStyle)
        ctx.theme.registerStyle("chat-drawer-container", dev.danko.roblox_craft_ai.uikit.components.ChatDrawerContainerStyle)
        ctx.theme.registerStyle("app-button-base", dev.danko.roblox_craft_ai.uikit.components.AppButtonBaseStyle)
        ctx.theme.registerStyle("primary-button", dev.danko.roblox_craft_ai.uikit.components.PrimaryButtonStyle)
        ctx.theme.registerStyle("secondary-button", dev.danko.roblox_craft_ai.uikit.components.SecondaryButtonStyle)
        ctx.theme.registerStyle("outline-button", dev.danko.roblox_craft_ai.uikit.components.OutlineButtonStyle)
        ctx.theme.registerStyle("ghost-button", dev.danko.roblox_craft_ai.uikit.components.GhostButtonStyle)
        ctx.theme.registerStyle("danger-button", dev.danko.roblox_craft_ai.uikit.components.DangerButtonStyle)
        ctx.theme.registerStyle("composer", dev.danko.roblox_craft_ai.uikit.components.ComposerStyle)
        ctx.theme.registerStyle("segmented", dev.danko.roblox_craft_ai.uikit.components.SegmentedStyle)
        ctx.theme.registerStyle("segment", dev.danko.roblox_craft_ai.uikit.components.SegmentStyle)
        ctx.theme.registerStyle("segment-active", dev.danko.roblox_craft_ai.uikit.components.SegmentActiveStyle)
        ctx.theme.registerStyle("composer-text-area", dev.danko.roblox_craft_ai.uikit.components.ComposerTextAreaStyle)
        ctx.theme.registerStyle("options-panel", dev.danko.roblox_craft_ai.uikit.components.OptionsPanelStyle)
        ctx.theme.registerStyle("ref-thumbnail-container", dev.danko.roblox_craft_ai.uikit.components.RefThumbnailContainerStyle)
        ctx.theme.registerStyle("mesh-viewer-container", dev.danko.roblox_craft_ai.uikit.components.MeshViewerContainerStyle)
        ctx.theme.registerStyle("mesh-controls-overlay", dev.danko.roblox_craft_ai.uikit.components.MeshControlsOverlayStyle)
        ctx.theme.registerStyle("timeline-surface", dev.danko.roblox_craft_ai.uikit.components.TimelineSurfaceStyle)
        ctx.theme.registerStyle("scrubber-container", dev.danko.roblox_craft_ai.uikit.components.ScrubberContainerStyle)
        ctx.theme.registerStyle("app-card", dev.danko.roblox_craft_ai.uikit.components.AppCardStyle)
        ctx.theme.registerStyle("app-card-hover", dev.danko.roblox_craft_ai.uikit.components.AppCardHoverStyle)
        ctx.theme.registerStyle("code-viewer-container", dev.danko.roblox_craft_ai.uikit.components.CodeViewerContainerStyle)
        ctx.theme.registerStyle("code-viewer-header", dev.danko.roblox_craft_ai.uikit.components.CodeViewerHeaderStyle)
        ctx.theme.registerStyle("asset-tile", dev.danko.roblox_craft_ai.uikit.components.AssetTileStyle)
        ctx.theme.registerVariant("-circle", dev.danko.roblox_craft_ai.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", dev.danko.roblox_craft_ai.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("side-menu-slide-in", dev.danko.roblox_craft_ai.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("pipeline-running-pulse", dev.danko.roblox_craft_ai.uikit.components.PipelineRunningPulseKeyframes)
        ctx.theme.registerKeyframes("app-button-spin", dev.danko.roblox_craft_ai.uikit.components.AppButtonSpinKeyframes)
        ctx.theme.registerKeyframes("modal-backdrop-fade-in", dev.danko.roblox_craft_ai.uikit.components.ModalBackdropFadeInKeyframes)
        ctx.theme.registerKeyframes("modal-sheet-enter", dev.danko.roblox_craft_ai.uikit.components.ModalSheetEnterKeyframes)
        dev.danko.roblox_craft_ai.initSiteStyles(ctx)
        dev.danko.roblox_craft_ai.initColorMode(ctx)
        dev.danko.roblox_craft_ai.initPageScroll(ctx)
        dev.danko.roblox_craft_ai.initStyles(ctx)
        dev.danko.roblox_craft_ai.initTheme(ctx)
        dev.danko.roblox_craft_ai.uikit.theme.initAppTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.danko.roblox_craft_ai.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
